"use client";

import { useRouter } from "next/navigation";
import { NextUIProvider } from "@nextui-org/react";
import { ThemeProvider } from "./theme-provider";
import React from "react";

interface NextUIWrapperProps {
  children: React.ReactNode
}

export default function NextUIWrapper({ children }: NextUIWrapperProps) {
  const router = useRouter();

  // Memoize router function to prevent unnecessary re-renders
  const handleNavigate = React.useCallback((href: string) => {
    return router.push(href as any);
  }, [router]);

  return (
    <NextUIProvider 
      navigate={handleNavigate} 
      className="h-full w-full flex flex-col"
    >
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem
        disableTransitionOnChange
      >
        {children}
      </ThemeProvider>
    </NextUIProvider>
  );
}